module.exports = __webpack_public_path__ + "img/18_15.d15c7c93.png";